import _ from 'lodash';

/**
 * Events
 * 
 * Attempt to partially translate Backbone 1.1.2 events to ES6 Class
 * https://github.com/jashkenas/backbone/blob/1.1.2/backbone.js#L68-L236
 */
class Events {

	constructor() {
		this.events = {};
		this.eventSplitter = /\s+/;
	}


	/**
	 * Implement fancy features of the Events API such as multiple event
	 * names `"change blur"` and jQuery-style event maps `{change: action}`
	 * in terms of the existing API.
	 */
	eventsApi(obj, action, name, rest) {
		if (!name) return true;

		// Handle event maps.
		if (typeof name === 'object') {
			for (let key in name) {
				obj[action].apply(obj, [key, name[key]].concat(rest));
			}
			return false;
		}

		// Handle space separated event names.
		if (this.eventSplitter.test(name)) {
			let names = name.split(this.eventSplitter);
			for (let i = 0, l = names.length; i < l; i++) {
				obj[action].apply(obj, [names[i]].concat(rest));
			}
			return false;
		}

		return true;
	}

	/**
	 * A difficult-to-believe, but optimized internal dispatch function
	 * for triggering events. Tries to keep the usual cases (3 or less 
	 * arguments) speedy.
	 */
	triggerEvents (events, args) {
		let ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
		switch (args.length) {
			case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
			case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
			case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
			case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
			default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
		}
	}

	/**
	 * Bind an event to a `callback` function. Passing `"all"` will bind
	 * the callback to all events fired.
	 */
	on(name, callback, context) {
		if (!this.eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
		let events = this.events[name] || (this.events[name] = []);
		events.push({callback: callback, context: context, ctx: context || this});
		return this;
	}

	/**
	 * Bind an event to only be triggered a single time. After the first time
	 * the callback is invoked, it will be removed.
	 */
	once(name, callback, context) {
		if (!this.eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
		
		let once = _.once(function() {
			this.off(name, once);
			callback.apply(this, arguments);
		});
		once._callback = callback;
		return this.on(name, once, context);
	}

	/**
	 * Remove one or many callbacks. If `context` is null, removes all
	 * callbacks with that function. If `callback` is null, removes all
	 * callbacks for the event. If `name` is null, removes all bound
	 * callbacks for all events.
	 */
	off(name, callback, context) {
		let 
		retain, 
		ev, events, 
		names, 
		i, l, j, k;

		if (!this.events || !this.eventsApi(this, 'off', name, [callback, context])) return this;
		if (!name && !callback && !context) {
			this.events = void 0;
			return this;
		}
		names = name ? [name] : Object.keys(this.events);
		
		for (i = 0, l = names.length; i < l; i++) {
			name = names[i];
			if (events = this.events[name]) {
				this.events[name] = retain = [];
				if (callback || context) {
					for (j = 0, k = events.length; j < k; j++) {
						ev = events[j];
						if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
							(context && context !== ev.context)) {
							retain.push(ev);
						}
					}
				}
				if (!retain.length) delete this.events[name];
			}
		}

		return this;
	}

	/**
	 * Trigger one or many events, firing all bound callbacks. Callbacks are
	 * passed the same arguments as `trigger` is, apart from the event name
	 * (unless you're listening on `"all"`, which will cause your callback to
	 * receive the true name of the event as the first argument).
	 */
	trigger(name) {
		if (!this.events) return this;

		var args = [].slice.call(arguments, 1);
		if (!this.eventsApi(this, 'trigger', name, args)) return this;

		let events = this.events[name];
		let allEvents = this.events.all;
		if (events) this.triggerEvents(events, args);
		if (allEvents) this.triggerEvents(allEvents, arguments);

		return this;
	}

	/**
	 * Tell this object to stop listening to either specific events ... or
	 * to every object it's currently listening to.
	 */
	/*stopListening(obj: Events, name: string, callback: Function | Events) {
		var listeningTo = this.listeningTo;
		if (!listeningTo) return this;
		var remove = !name && !callback;
		if (!callback && typeof name === 'object') callback = this; //??
		if (obj) (listeningTo = {})[obj._listenId] = obj;
		for (var id in listeningTo) {
			obj = listeningTo[id];
			obj.off(name, callback, this);
			if (remove || _.isEmpty(obj.events)) delete this.listeningTo[id];
		}
		return this;
	}*/

	/* 
	var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

	// Inversion-of-control versions of `on` and `once`. Tell *this* object to
	// listen to an event in another object ... keeping track of what it's
	// listening to.
	_.each(listenMethods, function(implementation, method) {
		Events[method] = function(obj, name, callback) {
		var listeningTo = this._listeningTo || (this._listeningTo = {});
		var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
		listeningTo[id] = obj;
		if (!callback && typeof name === 'object') callback = this;
		obj[implementation](name, callback, this);
		return this;
		};
	});
	*/

}

export default Events;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_utils/events.js